import React from 'react';
import {
  Button,
  IconButton,
  Tooltip
} from '@material-ui/core'
import { Edit, DeleteForever } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles';

const styles = {
  iconButton: {
    height: "48px"
  },
  deleteIcon: {
    color: "#FF0000"
  },
  iconContainer: {
    marginRight: "24px",
    minHeight: "48px"
  }
};

const useStyles = makeStyles(styles);

const CustomToolbar = (props) => {

  const classes = useStyles();

  const handleEdit = () => {
    props.setUpdate();
  };

  const handleDelete = () => {
    props.setDelete();
  };

  const renderAll = () => {
    switch (props.switchy) {
      
      // for Sales Orders.
      // values: --
      // functions: handleModalOpen
      case 0:
        return (
          <Tooltip title={"Cancel Sales Order"}>
            <IconButton className={classes.iconButton} onClick={props.handleModalOpen}>
              <DeleteForever className={classes.deleteIcon}/>
            </IconButton>
          </Tooltip>
        )
      
      // for products and customers.
      // values: element
      // functions: setUpdate
      case 1:
        return (
          <Tooltip title={`Edit ${props.element}`}>
            <IconButton className={classes.iconButton} onClick={handleEdit}>
              <Edit/>
            </IconButton>
          </Tooltip>
        )
      
      // for categories, companies, expenses and expense types.
      // values: element
      // functions: setDelete
      case 2:
        return (
          <Tooltip title={`Delete ${props.element}`}>
            <IconButton className={classes.iconButton} onClick={handleDelete}>
              <DeleteForever className={classes.deleteIcon}/>
            </IconButton>
          </Tooltip>
        )
      
      // for employees and vendors.
      // values: isVendor
      // functions: handleProcessModalOpen, updateExpected, setUpdate
      case 3:
        return (
          <React.Fragment>
            { props.isVendor ?
              <Tooltip title={"Show Vendor Processes"}>
                <Button className={classes.iconButton} onClick={props.handleProcessModalOpen}>
                  Show Processes
                </Button>
              </Tooltip>
            : null }
            <Tooltip title={props.isVendor ? "Update Expected Expense" : "Update Expected Salary"}>
              <Button className={classes.iconButton} onClick={props.updateExpected}>
                {props.isVendor ? "Expected Expense" : "Expected Salary"}
              </Button>
            </Tooltip>
            <Tooltip title={props.isVendor ? "Edit Vendor" : "Edit Employee"}>
              <IconButton className={classes.iconButton} onClick={handleEdit}>
                <Edit/>
              </IconButton>
            </Tooltip>
          </React.Fragment>
        )

      // for processes.
      // values: --
      // functions: updateSteps
      case 4:
        return (
          <Tooltip title={"Update Process Steps"}>
            <Button className={classes.iconButton} onClick={props.updateSteps}>
              Update Steps
            </Button>
          </Tooltip>
        )
      
      default:
        return (<React.Fragment></React.Fragment>)
    }
  };

  return (
    <div className={classes.iconContainer}>
    {renderAll()}
    </div>
  )
};

export default CustomToolbar;